import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "slot-padding" }
const _hoisted_2 = { class: "slot-padding" }
const _hoisted_3 = { class: "slot-padding" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  class: "circle"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: "#eeeeee"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  class: "circle"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    fill: "#eeeeee"
  })
], -1)

import { ref, computed, onMounted, watch } from "vue";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";

import { Organization } from "@/store/dictionaries/organizations";
import { usePermissionsStore, RoleDescription } from "@/store/auth/permissions";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";

interface ColumnPattern {
  field: string;
  header: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsTable',
  props: {
    organization: {},
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["setLoading"],
  setup(__props: any, { emit: __emit }) {

const permissionsStore = usePermissionsStore();
const authStore = useAuthStore();
const props = __props;

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["settings:edit", "system:edit"]);
});

const emits = __emit;
const columns = ref<ColumnPattern[]>([]);
const data = ref<any[]>([]);

const setData = () => {
  const rolesArray = [] as any[];
  props.organization?.departments.forEach((dep) => {
    dep.roles?.forEach((role) => {
      const tableStroke: any = { department: dep.name, role: role.name };

      permissionsStore.entitiesList.forEach((entity) => {
        if (
          permissionsStore.rolesPermissionsMap.has(`${role.id}_${entity.name}`)
        )
          tableStroke[entity.name] = permissionsStore.rolesPermissionsMap.get(
            `${role.id}_${entity.name}`
          );
        else
          tableStroke[entity.name] = {
            id: 0,
            name: "empty",
            role_id: role.id,
            entity_id: entity.id,
          };
      });

      rolesArray.push(tableStroke);
    });
  });
  data.value = rolesArray;
};

watch(
  () => props.organization,
  () => {
    setData();
  }
);

const loadData = () => {
  Promise.all([
    permissionsStore.getEntities(),
    permissionsStore.getRolesPermissions(),
    permissionsStore.getPermissions(),
  ]).then(() => {
    columns.value = [];
    permissionsStore.entitiesList.forEach((entity) => {
      columns.value.push({ field: entity.name, header: entity.display_name });
    });
    setData();
  });
};

onMounted(() => {
  loadData();
});

const onPermissionChange = (permission: RoleDescription) => {
  if (permission.id != 0 && permission.name == "empty") {
    permissionsStore.deletePermission(permission.id).then(() => {
      permission.id = 0;
    });
  } else {
    const permission_id = permissionsStore.permissionMap.get(permission.name);
    if (permission_id)
      permissionsStore
        .createRolePermission({
          entity_id: permission.entity_id,
          role_id: permission.role_id,
          permission_id: permission_id.id,
        })
        .then((data) => {
          if (data && data.id) {
            permission.id = data.id;
          }
        })
        .catch((err) => {
          if (err.response && err.response.status == 403)
            rootGetters.toast.show("warn", "Ошибка", "Нет доступа");
        });
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    value: data.value,
    class: _normalizeClass(["scroll-table-y main-table scrollbar-custom no-padding", [data.value && data.value.length == 0 ? 'empty-table' : '']]),
    stripedRows: "",
    scrollable: "",
    loading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "number",
        header: "№",
        style: {"width":"38px"}
      }, {
        body: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(slotProps.index + 1), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "department",
        header: "Подразделение"
      }, {
        body: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(slotProps.data["department"]), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "role",
        header: "Должность"
      }, {
        body: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(slotProps.data["role"]), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
        return (_openBlock(), _createBlock(_unref(Column), {
          key: col.field,
          field: col.field,
          header: col.header
        }, {
          body: _withCtx((slotProps) => [
            _createVNode(_unref(Dropdown), {
              modelValue: slotProps.data[slotProps.field].name,
              "onUpdate:modelValue": ($event: any) => ((slotProps.data[slotProps.field].name) = $event),
              options: _unref(permissionsStore).permissionsList,
              optionLabel: "display_name",
              optionValue: "name",
              panelClass: "panel-drop-right",
              class: "drop-right",
              disabled: isDenied.value,
              onChange: ($event: any) => (onPermissionChange(slotProps.data[slotProps.field]))
            }, {
              value: _withCtx((slotPropsOption) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["option", slotPropsOption.value])
                }, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_unref(permissionsStore).permissionMap.get(slotPropsOption.value)?.name), 1)
                ], 2)
              ]),
              option: _withCtx((slotPropsOption) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["option", slotPropsOption.option.name])
                }, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(slotPropsOption.option.display_name), 1)
                ], 2)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onChange"])
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "class", "loading"]))
}
}

})